import { render, staticRenderFns } from "./FormVerify.vue?vue&type=template&id=8e1f60fa&scoped=true"
import script from "./FormVerify.vue?vue&type=script&lang=js"
export * from "./FormVerify.vue?vue&type=script&lang=js"
import style0 from "./FormVerify.vue?vue&type=style&index=0&id=8e1f60fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1f60fa",
  null
  
)

export default component.exports